<template>
  <div class="header">
    <h1 class="title">{{ i18n.games }}</h1>
    <HeaderCloseIcon class="icon"
                     @click="hideLobby()" />
  </div>
</template>
<script>
import { inject } from 'vue';
import HeaderCloseIcon from './HeaderCloseIcon';

export default {
  name: 'Header',
  components: { HeaderCloseIcon },
  setup() {
    const i18n = inject('i18n');

    return {
      hideLobby() {
        window.parent.postMessage({
          action: 'HideLobby',
        }, '*');
      },
      i18n,
    };
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: grid;
  grid-template-columns: auto 80px;
  padding: 10px;
  padding-right: 20px;

  .title {
    font-size: 24px;
    margin: 0;
  }

  .icon {
    justify-self: end;
    cursor: pointer;
    padding: 5px;
    border-radius: 100%;
    transition: all 0.14s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    &:active {
      background: rgba(255, 255, 255, 0.2);
    }
  }
}
</style>
